import client from './client';

// ── Visitor Companies ────────────────────────────────────────
export async function listVisitorCompanies(params = {}) {
  const { data } = await client.get('/api/visitor-companies', { params });
  return data;
}
export async function createVisitorCompany(body) {
  const { data } = await client.post('/api/visitor-companies', body);
  return data;
}
export async function updateVisitorCompany(id, body) {
  const { data } = await client.put(`/api/visitor-companies/${id}`, body);
  return data;
}
export async function deleteVisitorCompany(id) {
  const { data } = await client.delete(`/api/visitor-companies/${id}`);
  return data;
}

// ── Visit Requests ───────────────────────────────────────────
export async function listVisitRequests(params = {}) {
  const { data } = await client.get('/api/visit-requests', { params });
  return data;
}
export async function getVisitRequest(id) {
  const { data } = await client.get(`/api/visit-requests/${id}`);
  return data;
}
export async function approveVisitRequest(id) {
  const { data } = await client.patch(`/api/visit-requests/${id}/approve`);
  return data;
}
export async function rejectVisitRequest(id, rejectionReason) {
  const { data } = await client.patch(`/api/visit-requests/${id}/reject`, { rejectionReason });
  return data;
}
export async function deleteVisitRequest(id) {
  const { data } = await client.delete(`/api/visit-requests/${id}`);
  return data;
}

// ── Visitor Cards ────────────────────────────────────────────
export async function listVisitorCards(params = {}) {
  const { data } = await client.get('/api/visitor-cards', { params });
  return data;
}
export async function createVisitorCards(body) {
  const { data } = await client.post('/api/visitor-cards', body);
  return data;
}
export async function deleteVisitorCard(id) {
  const { data } = await client.delete(`/api/visitor-cards/${id}`);
  return data;
}
export async function updateVisitorCardSettings(id, body) {
  const { data } = await client.patch(`/api/visitor-cards/${id}/settings`, body);
  return data;
}
export async function signInVisitorCard(id, body) {
  const { data } = await client.post(`/api/visitor-cards/${id}/sign-in`, body);
  return data;
}
export async function signOutVisitorCard(id) {
  const { data } = await client.post(`/api/visitor-cards/${id}/sign-out`);
  return data;
}
export async function markVisitorSafe(id) {
  const { data } = await client.post(`/api/visitor-cards/${id}/mark-safe`);
  return data;
}
export async function markVisitorEvacuated(id) {
  const { data } = await client.post(`/api/visitor-cards/${id}/mark-evacuated`);
  return data;
}
export async function bulkResetStatus(params) {
  const { data } = await client.post('/api/visitor-cards/bulk-reset-status', params);
  return data;
}

// ── Visitor Permanent Identity ───────────────────────────────
export async function createVisitor(body) {
  const { data } = await client.post('/api/visitors', body);
  return data;
}

export async function lookupVisitor(permanentId) {
  const { data } = await client.get(`/api/visitors/lookup/${permanentId}`);
  return data;
}
